import { render, staticRenderFns } from "./Instant.vue?vue&type=template&id=72b5363e"
import script from "./Instant.vue?vue&type=script&lang=js"
export * from "./Instant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports